import React from 'react';
import ReactDOM from 'react-dom/client';
import NewApp from "./Newapp"


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <NewApp />
  </React.StrictMode>
);
